const apiUrl = process.env.REACT_APP_API_URL;
const storageUrl = process.env.REACT_APP_STORAGE_URL;

const classUrl = process.env.REACT_APP_CLASS_URL;
const classApiUrl = process.env.REACT_APP_CLASS_API_URL;

const region = process.env.REACT_APP_REGION;

const passwordRegex = /^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Z!@#$%^&*]{6,}$/;
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export {apiUrl, storageUrl, passwordRegex, emailRegex, classUrl, classApiUrl, region};